export const environment = {
    production: true,
    syncfusionLicense: 'Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXlfcXRVQmhcVUd1VktWYE4='
};
